import { render, staticRenderFns } from "./AppAvatarDesktop.vue?vue&type=template&id=4da749b6&scoped=true"
import script from "./AppAvatarDesktop.vue?vue&type=script&lang=js"
export * from "./AppAvatarDesktop.vue?vue&type=script&lang=js"
import style0 from "./AppAvatarDesktop.vue?vue&type=style&index=0&id=4da749b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da749b6",
  null
  
)

export default component.exports